<template>
  <div class="app-wrapper">
    <sider></sider>
    <nav-bar></nav-bar>
    <main-content></main-content>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sider from './Sider'
import MainContent from './MainContent'
import NavBar from './NavBar'

export default {
  name: 'DashBoard',
  data() {
    return {
      activeIndex: 0
    }
  },
  components: {
    Sider,
    NavBar,
    MainContent
  },
  computed: {
    ...mapGetters([
      'isCollapse',
      'currentUser'
    ])
  },
  created() {
    const route = this.$route
    const { meta } = route
    console.log('this.currentUser = ', this.currentUser)
    console.log('meta', meta.index)
    this.activeIndex = meta.index
    console.log('this.isCollapse', this.isCollapse)
  },
  watch: {
    $route: {
      handler: function (route) {
        const { meta } = route
        if (meta) {
          this.activeIndex = meta.index
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.$store.commit('app/SET_IS_COLLAPSE', true)
    },
    handleOpen() {
      this.$store.commit('app/SET_IS_COLLAPSE', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue